import { z } from 'zod'
import { YesOrNoSchema } from './application-shared.schema'
import { isInvalidString, REQUIRED_BASIC_MESSAGE } from '../constants/constants'
import { SchoolSchema } from '@/schemas/school-application.schema.ts'

export const MailingAddressSchema = z
  .object({
    isMailingAddressSame: YesOrNoSchema,
    mailingStreetAddress: z.string().optional(),
    mailingStreetAddress2: z.string().optional(),
    mailingCity: z.string().optional(),
    mailingState: z.string().optional(),
    mailingZipCode: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    console.log('Validating, isMailingAddressSame =', data.isMailingAddressSame)
    // Conditional validation for mailing address
    if (data.isMailingAddressSame === 'No') {
      if (isInvalidString(data.mailingStreetAddress)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['mailingStreetAddress'],
          message: 'Mailing Street Address is required ',
        })
      }
      // mailingStreetAddress2 is optional even if mailing address is different
      if (isInvalidString(data.mailingCity)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['mailingCity'],
          message: REQUIRED_BASIC_MESSAGE,
        })
      }
      if (isInvalidString(data.mailingState)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['mailingState'],
          message: REQUIRED_BASIC_MESSAGE,
        })
      }
      if (isInvalidString(data.mailingZipCode)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['mailingZipCode'],
          message: REQUIRED_BASIC_MESSAGE,
        })
      }
    }
  })

export type MailingAddress = z.infer<typeof MailingAddressSchema>
export type School = z.infer<typeof SchoolSchema>
